import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

// UUID discreto sob o título; clicar no próprio UUID copia
// (sem rótulo "copiar"; affordance sutil no hover).
export function UuidLine({ uuid }: { uuid: string }) {
  const copy = useCopyToClipboard();
  return (
    <button
      type="button"
      onClick={() => copy(uuid, "UUID copiado.")}
      title="Clique para copiar"
      aria-label={`Copiar UUID ${uuid}`}
      className="font-mono text-[11px] text-text-tertiary transition-colors hover:text-text-secondary hover:underline"
    >
      {uuid}
    </button>
  );
}
